import { Extent } from 'ol/extent';
import Static from 'ol/source/ImageStatic';
import { WorldInfoInterface } from './model/config-api-response.interface';

export function createStaticImageLayerSource(objectUrn: string, baseUrl: string, worldInfo: WorldInfoInterface, f: () => void): Static {
  console.log("WorldInfo", worldInfo);

  // Compose url from the provided baseUrl.
  let url = baseUrl
  .replace("{b}", worldInfo.bounds.xmin + "," + worldInfo.bounds.ymin + "," + worldInfo.bounds.xmax + "," + worldInfo.bounds.ymax)
  .replace("{w}", objectUrn.includes("mit_hub") ? "2048" : "4096")
  .replace("{h}", objectUrn.includes("mit_hub") ? "2048" : "4096")
  .replace("{i}", worldInfo.world_urn);

  const extent: Extent = extentFromWorldInfo(worldInfo)
    // projection: 'EPSG:3857', // Default is the view projection
    // interpolate: true, // clearer shit
    // imageSize: [691, 541], // Usually the image size is auto-detected
    // imageExtent: applyTransform([-74.22655, 40.71222, -74.12544, 40.77394], getTransform("EPSG:4326", "EPSG:3857"))
  const source = new Static({
    url: url,
    imageSmoothing: false,
    imageExtent: extent,
    imageLoadFunction: f,
  });

  return source;
}

/**
 * Computes an Extent from the provided world's bounds.
 * @param worldInfo Data about the current feature's world.
 */
export function extentFromWorldInfo(worldInfo: WorldInfoInterface): Extent{
  const extent: Extent = [worldInfo.bounds.xmin, worldInfo.bounds.ymin, worldInfo.bounds.xmax, worldInfo.bounds.ymax];
  return extent;
}

// better using fetch ???? BOOOOH
// async function postData(image ,url = '') {
//   // Default options are marked with *
//   const response = await fetch(url, {
//     method: 'POST', // *GET, POST, PUT, DELETE, etc.
//     mode: 'cors', // no-cors, *cors, same-origin
//     cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
//     credentials: 'same-origin', // include, *same-origin, omit
//     headers: {
//       'Bearer': 'token'
//     },
    
//     redirect: 'follow', // manual, *follow, error
//     referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
//     body: JSON.stringify('') // body data type must match "Content-Type" header
//   }).catch(reason => image.setState(TileState.ERROR))
//   if(response!= undefined) {
//     image.getImage().src = URL.createObjectURL(response);
//   } else {
//     image.setState(TileState.ERROR);
//   }
//   // response.json(); // parses JSON response into native JavaScript objects
// }
